import React from 'react';
import { Divider } from '@material-ui/core';
import SectionHeading from './SectionHeading';

// One setting per row: name (with its hover help) on the left, its control on
// the right. Same shape as the integrations list, so the tabs read alike.
//
// `dense` is for rows inside a dialog, where a rule between every field just
// chops a short form into slices and wastes vertical space. Top-level cards
// keep the dividers, because there the rows are unrelated settings rather than
// one group.
//
// Rows wrap rather than squash on narrow screens — a timezone picker crushed
// into 80px is worse than one that drops onto its own line.
const SettingRow = ({ label, help, children, last, id, dense = false }) => (
  <>
    <div
      id={id}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 12,
        padding: dense ? '6px 20px' : '12px 20px',
        minHeight: dense ? 40 : 56,
      }}
    >
      <div style={{ flex: '1 1 220px', minWidth: 0 }}>
        <SectionHeading label={label} help={help} gutter={0} />
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
        {children}
      </div>
    </div>
    {last || dense ? undefined : <Divider />}
  </>
);

export default SettingRow;
